import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import styled from 'styled-components';
import { styleVariables } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// Color palette per status id (display status)
var STATUS_STYLE = {
  '5': {
    dot: '#FA8C16',
    activeBg: '#FFF7E6',
    activeBorder: '#FFD591',
    activeColor: '#FA8C16'
  },
  '6': {
    dot: '#1A5AFF',
    activeBg: '#E6F2FF',
    activeBorder: '#1A5AFF',
    activeColor: '#1A5AFF'
  },
  '7': {
    dot: '#9254DE',
    activeBg: '#F9F0FF',
    activeBorder: '#B37FEB',
    activeColor: '#9254DE'
  },
  '8': {
    dot: '#3A8814',
    activeBg: '#E8FCD5',
    activeBorder: '#52C41A',
    activeColor: '#3A8814'
  }
};
var DEFAULT_ACTIVE_STYLE = {
  dot: styleVariables.colors.blue2,
  activeBg: styleVariables.colors.blue1,
  activeBorder: styleVariables.colors.blue2,
  activeColor: styleVariables.colors.blue2
};
var StyledBar = styled.div.withConfig({
  displayName: "status-filter-barcomponent__StyledBar",
  componentId: "sc-1otrxs3-0"
})(["display:flex;flex-wrap:wrap;gap:8px;align-items:center;"]);
var StyledPill = styled.button.withConfig({
  displayName: "status-filter-barcomponent__StyledPill",
  componentId: "sc-1otrxs3-1"
})(["display:inline-flex;align-items:center;gap:6px;padding:5px 14px;border-radius:20px;border:1.5px solid ", ";background-color:", ";color:", ";font-size:13px;font-weight:", ";cursor:pointer;transition:all 0.18s ease;white-space:nowrap;line-height:1.4;&:hover{border-color:", ";color:", ";background-color:", ";}"], function (_ref) {
  var $active = _ref.$active,
      $activeBorder = _ref.$activeBorder;
  return $active ? $activeBorder : styleVariables.colors.grey14;
}, function (_ref2) {
  var $active = _ref2.$active,
      $activeBg = _ref2.$activeBg;
  return $active ? $activeBg : '#ffffff';
}, function (_ref3) {
  var $active = _ref3.$active,
      $activeColor = _ref3.$activeColor;
  return $active ? $activeColor : styleVariables.colors.grey100;
}, function (_ref4) {
  var $active = _ref4.$active;
  return $active ? 600 : 400;
}, function (_ref5) {
  var $activeBorder = _ref5.$activeBorder;
  return $activeBorder;
}, function (_ref6) {
  var $activeColor = _ref6.$activeColor;
  return $activeColor;
}, function (_ref7) {
  var $active = _ref7.$active,
      $activeBg = _ref7.$activeBg;
  return $active ? $activeBg : "".concat(_hexToRgba($activeBg, 0.5));
});
var StyledDot = styled.span.withConfig({
  displayName: "status-filter-barcomponent__StyledDot",
  componentId: "sc-1otrxs3-2"
})(["width:7px;height:7px;border-radius:50%;background-color:", ";flex-shrink:0;transition:background-color 0.18s ease;"], function (_ref8) {
  var $color = _ref8.$color,
      $active = _ref8.$active;
  return $active ? $color : styleVariables.colors.gray11;
}); // Simple hex → rgba helper (no external dep)

function _hexToRgba(hex, alpha) {
  try {
    var clean = hex.replace('#', '');
    var r = parseInt(clean.substring(0, 2), 16);
    var g = parseInt(clean.substring(2, 4), 16);
    var b = parseInt(clean.substring(4, 6), 16);
    return "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(alpha, ")");
  } catch (_unused) {
    return hex;
  }
}

var ALL_STATUS_ID = '';
export var StatusFilterBar = function StatusFilterBar(_ref9) {
  var options = _ref9.options,
      activeStatus = _ref9.activeStatus,
      onStatusChange = _ref9.onStatusChange,
      labels = _ref9.labels;
  var allOptions = [{
    id: ALL_STATUS_ID,
    label: labels.all
  }].concat(_toConsumableArray(options));
  return /*#__PURE__*/_jsx(StyledBar, {
    children: allOptions.map(function (option) {
      var _STATUS_STYLE$option$;

      var isActive = activeStatus === option.id;
      var style = option.id === ALL_STATUS_ID ? DEFAULT_ACTIVE_STYLE : (_STATUS_STYLE$option$ = STATUS_STYLE[option.id]) !== null && _STATUS_STYLE$option$ !== void 0 ? _STATUS_STYLE$option$ : DEFAULT_ACTIVE_STYLE;
      return /*#__PURE__*/_jsxs(StyledPill, {
        type: "button",
        $active: isActive,
        $dot: style.dot,
        $activeBg: style.activeBg,
        $activeBorder: style.activeBorder,
        $activeColor: style.activeColor,
        onClick: function onClick() {
          return onStatusChange(option.id);
        },
        children: [option.id !== ALL_STATUS_ID && /*#__PURE__*/_jsx(StyledDot, {
          $color: style.dot,
          $active: isActive
        }), option.label]
      }, option.id);
    })
  });
};